import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at top left, #4f46e5 0, #1d2433 45%, #020617 100%)',
        padding: '24px',
        color: '#e5e7eb',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          background: 'rgba(15, 23, 42, 0.9)',
          borderRadius: 24,
          padding: '32px 28px 28px',
          boxShadow:
            '0 24px 60px rgba(15, 23, 42, 0.9), 0 0 0 1px rgba(148, 163, 184, 0.12)',
          backdropFilter: 'blur(16px)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 999,
              background:
                'conic-gradient(from 160deg at 50% 50%, #38bdf8, #4f46e5, #22c55e, #38bdf8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 12,
              boxShadow: '0 0 0 1px rgba(15, 23, 42, 0.9)',
            }}
          >
            <span
              style={{
                fontWeight: 800,
                color: '#0b1120',
                fontSize: 18,
                letterSpacing: 0.4,
              }}
            >
              H
            </span>
          </div>
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: 24,
                fontWeight: 700,
                letterSpacing: 0.4,
                color: '#f9fafb',
              }}
            >
              Heimdall
            </h1>
            <p
              style={{
                margin: '2px 0 0',
                fontSize: 13,
                color: '#9ca3af',
              }}
            >
              Accede a tu panel de auditorías y evidencias.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label
              style={{
                display: 'block',
                marginBottom: 6,
                fontSize: 13,
                fontWeight: 500,
                color: '#e5e7eb',
              }}
            >
              Usuario
            </label>
            <div
              style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  left: 10,
                  color: '#6b7280',
                  fontSize: 14,
                }}
              >
                @
              </span>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                placeholder="tu.usuario"
                style={{
                  width: '100%',
                  padding: '9px 12px 9px 26px',
                  borderRadius: 12,
                  border: '1px solid rgba(148, 163, 184, 0.6)',
                  backgroundColor: 'rgba(15, 23, 42, 0.85)',
                  color: '#e5e7eb',
                  fontSize: 14,
                  outline: 'none',
                  boxShadow: '0 0 0 0 transparent',
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: 8 }}>
            <label
              style={{
                display: 'block',
                marginBottom: 6,
                fontSize: 13,
                fontWeight: 500,
                color: '#e5e7eb',
              }}
            >
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="•••••••••"
              style={{
                width: '100%',
                padding: '9px 12px',
                borderRadius: 12,
                border: '1px solid rgba(148, 163, 184, 0.6)',
                backgroundColor: 'rgba(15, 23, 42, 0.85)',
                color: '#e5e7eb',
                fontSize: 14,
                outline: 'none',
              }}
            />
          </div>

          {error && (
            <div
              style={{
                marginBottom: 12,
                padding: '8px 10px',
                borderRadius: 10,
                background: 'rgba(220, 38, 38, 0.12)',
                color: '#fecaca',
                fontSize: 13,
                border: '1px solid rgba(248, 113, 113, 0.4)',
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              marginTop: 8,
              padding: '10px 14px',
              borderRadius: 999,
              border: 'none',
              fontSize: 14,
              fontWeight: 600,
              letterSpacing: 0.4,
              cursor: loading ? 'default' : 'pointer',
              color: '#0b1120',
              background:
                loading
                  ? 'linear-gradient(to right, #6b7280, #4b5563)'
                  : 'linear-gradient(135deg, #22c55e, #16a34a, #22c55e)',
              boxShadow: loading
                ? '0 0 0 rgba(0,0,0,0)'
                : '0 18px 40px rgba(22, 163, 74, 0.55)',
              transition: 'transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease',
              opacity: loading ? 0.85 : 1,
            }}
          >
            {loading ? 'Accediendo...' : 'Entrar en Heimdall'}
          </button>
        </form>

        <div
          style={{
            marginTop: 18,
            fontSize: 11,
            color: '#6b7280',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span>Plataforma interna de auditorías.</span>
          <span style={{ opacity: 0.8 }}>Heimdall v1.7 {new Date().getFullYear()}</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
